import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "catalog-products__search" };
const _hoisted_2 = { class: "catalog-products__title" };
const _hoisted_3 = { class: "catalog-products__controls" };
const _hoisted_4 = { class: "catalog-products__totals" };
const _hoisted_5 = { class: "catalog-products__actions" };
const _hoisted_6 = { class: "catalog-products__results" };
const _hoisted_7 = {
    key: 0,
    class: "catalog-products__list"
};
const _hoisted_8 = {
    key: 0,
    class: "catalog-products__show-more"
};
import { ref, onMounted, watch, computed, onUnmounted } from 'vue';
import productRepository from "@astina/paloma-shop-common-ui/src/services/ProductRepository";
import alerts from "@astina/paloma-common-ui/src/services/Alerts";
import trans from "@astina/paloma-common-ui/src/services/Translator";
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import CatalogListItem from "./CatalogListItem.vue";
import config from "../services/PortalConfig";
import CatalogProductsControls from "./CatalogProductsControls.vue";
import events from '@astina/paloma-common-ui/src/services/EventBus';
import CatalogExportButtons from "./CatalogExportButtons.vue";
import CatalogSearchInput from "./CatalogSearchInput.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogProducts',
    props: {
        categoryCode: {},
        searchQuery: {},
        viewMode: {}
    },
    setup(__props) {
        const props = __props;
        const loading = ref(false);
        const category = ref(null);
        const filters = ref(null);
        const page = ref(null);
        const products = ref(null);
        const searchRequest = ref({
            query: props.searchQuery || undefined,
            category: props.categoryCode || undefined,
            page: 0,
            size: config.catalog.pageSize,
            filterAggregates: true,
            totalAggregates: true,
        });
        const hasMoreProducts = computed(() => !page.value?.last);
        onMounted(loadCategory);
        watch(() => props.categoryCode, () => {
            resetResultsPage();
            products.value = null;
            loading.value = true;
            loadCategory();
            searchRequest.value.category = props.categoryCode || undefined;
            searchRequest.value.query = undefined;
            searchRequest.value.filters = [];
        });
        onMounted(searchProducts);
        watch(searchRequest, searchProducts, { deep: true });
        function resetResultsPage() {
            page.value = null;
            searchRequest.value.page = 0;
        }
        function onSelectSort(sort, order) {
            searchRequest.value.sort = sort;
            searchRequest.value.order = order;
            resetResultsPage();
            // => modifying searchRequest triggers searchProducts()
            // TODO save in uiSettings?
        }
        function onSelectViewMode(mode) {
            events.$emit('catalog.select-view-mode', mode);
        }
        function loadCategory() {
            filters.value = null;
            if (!props.categoryCode) {
                category.value = null;
                productRepository.listFilters()
                    .then(data => filters.value = data);
                return;
            }
            productRepository.getCategory(props.categoryCode || '', 0, true)
                .then(data => {
                category.value = data;
                filters.value = data.filterAggregates || [];
            })
                .catch(() => {
                alerts.error(trans('catalog.category_not_found'));
                category.value = null;
            });
        }
        function searchProducts() {
            page.value = null;
            loading.value = true;
            productRepository.searchProducts(searchRequest.value)
                .then(onProductsPageLoaded)
                .catch(() => {
                alerts.error(trans('catalog.search_error'));
            })
                .finally(() => loading.value = false);
        }
        function onSearchRequestUpdate(sr) {
            searchRequest.value.query = sr.query;
            searchRequest.value.filters = sr.filters;
            searchRequest.value.page = 0;
        }
        function onProductsPageLoaded(page_) {
            page.value = page_;
            if (products.value === null || page_.number === 0) {
                products.value = page_.content || [];
            }
            else {
                page_.content.forEach(product => products.value.push(product));
            }
            if (page_.aggregates) {
                filters.value = page_.aggregates;
            }
        }
        function loadMoreProducts() {
            searchRequest.value.page = (searchRequest.value.page || 0) + 1;
            // => modifying searchRequest triggers searchProducts()
        }
        // endless scrolling
        onMounted(() => events.$on('catalog.products-scroll', onCatalogScroll));
        onUnmounted(() => events.$off('catalog.products-scroll', onCatalogScroll));
        function onCatalogScroll(event) {
            const element = event.target;
            const threshold = 100; // pixels from bottom to trigger load
            if (element.scrollHeight - element.scrollTop - element.clientHeight < threshold) {
                if (hasMoreProducts.value && !loading.value) {
                    loadMoreProducts();
                }
            }
        }
        const countTranslationKey = computed(() => {
            if (page.value?.totalElements === 0) {
                return 'catalog.products_count_none';
            }
            if (page.value?.totalElements === 1) {
                return 'catalog.products_count_one';
            }
            return 'catalog.products_count';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["catalog-products", { 'catalog-products--list': __props.viewMode === 'list', 'catalog-products--grid': __props.viewMode === 'grid' }])
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h1", _hoisted_2, _toDisplayString(category.value?.name || _ctx.$t('catalog.all_categories')), 1),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createVNode(CatalogSearchInput, {
                        "search-request": searchRequest.value,
                        filters: filters.value || [],
                        onUpdate: onSearchRequestUpdate
                    }, null, 8, ["search-request", "filters"])
                ]),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(Spinner, {
                            loading: loading.value || !page.value
                        }, null, 8, ["loading"]),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        (!loading.value && page.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t(countTranslationKey.value, { count: page.value.totalElements })), 1)
                            ], 64))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(CatalogExportButtons, {
                            "search-request": searchRequest.value,
                            version: "v2",
                            "button-style": "link"
                        }, null, 8, ["search-request"])
                    ]),
                    _cache[3] || (_cache[3] = _createTextVNode()),
                    _createVNode(CatalogProductsControls, {
                        sort: searchRequest.value.sort,
                        "sort-direction": searchRequest.value.order,
                        onSelectSort: onSelectSort,
                        mode: __props.viewMode,
                        onSelectMode: onSelectViewMode
                    }, null, 8, ["sort", "sort-direction", "mode"])
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("div", _hoisted_6, [
                    (products.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
                                return (_openBlock(), _createBlock(CatalogListItem, {
                                    class: "catalog-products__list-item",
                                    tabindex: "0",
                                    item: product,
                                    "view-mode": __props.viewMode,
                                    key: product.id
                                }, null, 8, ["item", "view-mode"]));
                            }), 128)),
                            _cache[5] || (_cache[5] = _createTextVNode()),
                            (hasMoreProducts.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    ((searchRequest.value.page || 0) > 0)
                                        ? (_openBlock(), _createBlock(Spinner, {
                                            key: 0,
                                            loading: loading.value
                                        }, null, 8, ["loading"]))
                                        : _createCommentVNode("", true),
                                    _cache[4] || (_cache[4] = _createTextVNode()),
                                    (!loading.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            onClick: _withModifiers(loadMoreProducts, ["prevent"]),
                                            class: "button button--outline"
                                        }, _toDisplayString(_ctx.$t('catalog.show_more_items')), 1))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ], 2));
        };
    }
});
